module.exports = __webpack_public_path__ + "static/classhook-dashboard-daedbf4c7c6740aaf40e1e1a2675da18.jpg";